﻿/* global TD */
import $ from "jquery";

// shim layer with setTimeout fallback
var requestAnimFrame = (function() {
	return window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function(callback) {
			window.setTimeout(callback, 1000 / 60);
		};
})();

var Paint = function(options) {
	var canvas = options.el;

	var ctx = canvas.getContext("2d");
	ctx.lineCap = options.lineCap || "round";
	ctx.fillStyle = "white";
	ctx.fillRect(0, 0, canvas.width, canvas.height);
	this.ctx = ctx;
	this.isEmpty = true;
	this.canvas = canvas;
	this.lines = {};
	this.pointers = {};
	this.initEvents();
	requestAnimFrame(this.renderLoop.bind(this));
};

Paint.prototype.initEvents = function() {
	var canvas = this.canvas;
	canvas.addEventListener('pointerdown', this.onPointerDown.bind(this));
	canvas.addEventListener('pointermove', this.onPointerMove.bind(this));
	canvas.addEventListener('pointerup', this.onPointerUp.bind(this));
	canvas.addEventListener('pointercancel', this.onPointerUp.bind(this));
	canvas.addEventListener('pointerleave', this.onPointerUp.bind(this));
};

Paint.prototype.onPointerDown = function(event) {
	var minwidth = 2, maxwidth = 5;
	var width = event.pointerType === 'touch' ? (event.width || maxwidth) : maxwidth;
	width = Math.min(Math.max(minwidth, width), maxwidth);
	this.pointers[event.pointerId] = new Pointer({ x: event.clientX, y: event.clientY, width: width });
	event.preventDefault();
};

Paint.prototype.onPointerMove = function(event) {
	var pointer = this.pointers[event.pointerId];
	if(pointer) {
		pointer.setTarget({ x: event.clientX, y: event.clientY });
	}
};

Paint.prototype.onPointerUp = function(event) {
	delete this.pointers[event.pointerId];
};

Paint.prototype.renderLoop = function() {
	var dx, dy;
	for(var pointerId in this.pointers) {
		var pointer = this.pointers[pointerId];
		if(pointer.isDelta()) {
			var ctx = this.ctx;
			if(!dx) {
				var c = this.canvas;
				var r = c.getBoundingClientRect();
				dx = c.width / r.width;
				dy = c.height / r.height;
			}
			ctx.lineWidth = pointer.width;
			ctx.strokeStyle = pointer.color;
			ctx.beginPath();
			ctx.moveTo(pointer.x * dx, pointer.y * dy);
			ctx.lineTo(pointer.targetX * dx, pointer.targetY * dy);
			ctx.stroke();
			ctx.closePath();
			this.isEmpty = false;
			pointer.didReachTarget();
		}
	}
	requestAnimFrame(this.renderLoop.bind(this));
};

Paint.prototype.clear = function() {
	this.ctx.fillStyle = "white";
	this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
	this.isEmpty = true;
};

function Pointer(options) {
	this.x = options.x;
	this.y = options.y;
	this.width = options.width;
	this.color = options.color || "black";
}

Pointer.prototype.setTarget = function(options) {
	this.targetX = options.x;
	this.targetY = options.y;
};

Pointer.prototype.didReachTarget = function() {
	this.x = this.targetX;
	this.y = this.targetY;
};

Pointer.prototype.isDelta = function() {
	return this.targetX && this.targetY &&
		(this.x != this.targetX || this.y != this.targetY);
};

function delayedRunOnResize(f) {
	var t = 0;
	$(window).on("resize", function() {
		if(t !== 0) clearTimeout(t);
		t = setTimeout(function() { t = 0; f(); }, 100);
	});
	f();
}

function onresize(canvas) {
	var resampled = removeBlanks(canvas);

	var p = $(canvas).parent();
	var dx = p.width();
	var dy = p.height();

	if(dx > 800 || dy > 800) {
		if(dx > dy) { // landscape
			dy *= 800 / dx;
			dx = 800;
		}
		else { // portrait
			dx *= 800 / dy;
			dy = 800;
		}
	}
	canvas.width = dx;
	canvas.height = dy;
	var ctx = canvas.getContext("2d");
	ctx.lineCap = "round";
	ctx.fillStyle = "white";
	ctx.fillRect(0, 0, canvas.width, canvas.height);
	if(resampled != null) { // copy image
		var sx = resampled.width, sy = resampled.height;
		ctx.drawImage(resampled, 0, 0, sx, sy,
			(dx - sx) / 2, (dy - sy) / 2, sx, sy);
	}
}

function isBlank(data, i) {
	return data[i] == 255 && data[i + 1] == 255 && data[i + 2] == 255;
}

function scanY(imageData, fromTop) {
	var w = imageData.width;
	var data = imageData.data;
	var b = 0, e = data.length, off = 4;
	if(!fromTop) {
		b = e - 4; e = -4; off = -4;
	}
	for(; b != e; b += off) {
		if(!isBlank(data, b)) {
			return (b / (w * 4)) | 0;
		}
	}
	return null;
}

function scanX(imageData, fromLeft) {
	var w = imageData.width * 4;
	var data = imageData.data;
	var l = data.length;
	var b = 0, e = w, off = 4;
	if(!fromLeft) {
		b = e - 4; e = -4; off = -4;
	}
	for(; b != e; b += off) {
		for(var i = b; i < l; i += w) {
			if(!isBlank(data, i)) {
				return (b / 4) | 0;
			}
		}
	}
	return null;
}

function removeBlanks(canvas) {
	var width = canvas.width, height = canvas.height;
	var imageData = canvas.getContext("2d").getImageData(0, 0, width, height);

	var top = scanY(imageData, true);
	if(top == null) return null;
	height = scanY(imageData, false) + 1 - top;
	var left = scanX(imageData, true);
	width = scanX(imageData, false) + 1 - left;

	var resampled = document.createElement("canvas");
	resampled.width = width;
	resampled.height = height;
	resampled.getContext("2d").drawImage(canvas, left, top, width, height, 0, 0, width, height);
	return resampled;
}

function startSignature(output) {

	var content = $("<canvas width=\"800\" height=\"800\" touch-action=\"none\"></canvas>");
	var paint = new Paint({ el: content[0] });

	var buttons = {};

	buttons[TD.Res["signature.action.done"]] = function() {
		var result = "";
		if(!paint.isEmpty) {
			var resampled = removeBlanks(content[0]);
			if(resampled != null)
				result = resampled.toDataURL("image/png", 0);
		}
		if(output.val() != result) {
			output.val(result).trigger("change");
		}
		content.dialog("close");
	};

	buttons[TD.Res["signature.action.reset"]] = function() {
		paint.clear();
	};

	buttons[TD.Res["action.cancel"]] = function() {
		content.dialog("close");
	};

	var meta = $("head > meta[name=viewport]");
	var metaContent = meta.attr("content");
	meta.attr("content", "width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no,shrink-to-fit=no");
	setTimeout(function() { meta.attr("content", metaContent); }, 1000);

	content.dialog({
		autoOpen: true,
		modal: true,
		closeOnEscape: true,
		draggable: false,
		resizable: false,
        title: TD.Res["signature.title"],
		classes: { "ui-dialog": "ui-popup td-signature-dialog td-embedded" },
		open: function() {
			$("body").css("overflow", "hidden");
			$(this)
			.closest(".ui-dialog")
			.css({ position: "", left: "", right: "", top: "", bottom: "", width: "", height: "" })
			.find(">.ui-dialog-buttonpane>.ui-dialog-buttonset>button:first-child")
			.addClass("blue");
			var me = this;
			delayedRunOnResize(function() { onresize(me); });
		},
		close: function() {
			$("body").css("overflow", "");
		},
		buttons: buttons
	});
}

function initSignature() {

	function createPreview(container, src) {
		container.find(">img").remove();
		if(src) {
			src = src.replace(/^attachment\.aspx\?fid=/, "image.aspx?w=480&fid=");
			$("<img>", { src: src }).css({ display: "block" }).prependTo(container);
		}
	}

	function createSignoffButton(container, output) {
		container.find(">button").remove();
		$("<button>", { type: "button", "class": "ui-button" }).text(TD.Res["signature.action.sign_off"]).on("click", function() {
			startSignature(output);
		}).appendTo(container);
	}

	function createWithdrawButton(container, output, confirm) {
		container.find(">button").remove();
		$("<button>", { type: "button", "class": "ui-button" }).text(TD.Res["signature.action.withdraw"]).on("click", function() {
			if(!confirm || window.confirm(TD.Res["signature.action.withdraw.confirmation"])) {
				createPreview(container, "");
				container.find(">input[type=\"checkbox\"]").attr("checked", true);
				createSignoffButton(container, output);
			}
		}).appendTo(container);
	}

	function init() {
		var name = this.name;
		var me = $(this);
		var src = me.data("fileurl");
		var srcData = /^data:/.test(src || "") ? src : "";
		var allowRemove = src != null && me.data("allowremove") != null;
		var container = $(this).parent().empty();

		var output = $("<input>", { name: name + "_sign", type: "hidden", value: srcData })
			.on("change", function() {
				createPreview(container, this.value);
				createWithdrawButton(container, output);
			}).appendTo(container);

		createPreview(container, src);
		if(allowRemove) {
			createWithdrawButton(container, output, true);
			$("<input>", { name: name + "_delete", type: "checkbox" }).hide().appendTo(container);
		}
		else {
			createSignoffButton(container, output);
		}
	}

	$("input[type=\"file\"][data-signature]").each(init);
}

export { initSignature };
